import { createAsyncThunk } from "@reduxjs/toolkit";
import * as profileApi from "../../api/requests/profile";
import * as postApi from "../../api/requests/post";
export const getVisitedProfile = createAsyncThunk(
  "visitedProfile/getVisitedProfile",
  async (username) => {
    try {
      const response = await profileApi.getProfileByUsername(username);
      return response;
    } catch (error) {
      return error;
    }
  },
);
export const followVisitedProfile = createAsyncThunk(
  "visitedProfile/getVisitedProfile",
  async (username) => {
    try {
      const response = await profileApi.followByUsername(username);
      return response;
    } catch (error) {
      return error;
    }
  },
);
export const unFollowVisitedProfile = createAsyncThunk(
  "visitedProfile/getVisitedProfile",
  async (username) => {
    try {
      const response = await profileApi.unFollowUsername(username);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getProfilePosts = createAsyncThunk(
  "currentProfile/getProfilePosts",
  async (username) => {
    try {
      const response = await postApi.getProfilePosts(username);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const getProfileReplies = createAsyncThunk(
  "currentProfile/getProfileReplies",
  async (username) => {
    try {
      const response = await postApi.getProfileReplies(username);
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const suspendVisitedProfile = createAsyncThunk(
  "visitedProfile/suspendVisitedProfile",
  async (username) => {
    try {
      const response = await profileApi.suspendUser(username);
      return response;
    } catch (error) {
      return error;
    }
  },
);

